import { LOADING_FLAG, LOADING_TIP } from '../actionTypes/loadingTypes'
const initState = {
  loading: false,
  tip: ''
}
const loadingReducer = (state = initState, action) => {
  const { type, payload } = action
  switch (type) {
    case LOADING_FLAG:
      return {
        ...state,
        loading: payload
      }
    case LOADING_TIP:
      return {
        ...state,
        tip: payload
      }
    default:
      return {
        ...state
      }
  }
}
export default loadingReducer
